import { SMS_TRACKING_PERIODS, SMS_TRACKING_STATUSES } from '@gozoki/api-types'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { SmsTrackingPage } from '~/components/routes/hr/sms-tracking/sms-tracking-page'
import { Button } from '~/components/ui/button'

const searchSchema = z.object({
  period: z.enum(SMS_TRACKING_PERIODS).optional(),
  storeId: z.number().int().positive().optional(),
  status: z.enum(SMS_TRACKING_STATUSES).optional(),
  search: z.string().optional(),
  page: z.number().int().positive().optional(),
  pageSize: z.number().int().positive().optional(),
})

export const Route = createFileRoute('/_authenticated/hr/sms-tracking')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <AppHeader>
        <Title>Suivis des SMS - Publication du planning</Title>
      </AppHeader>
      <AppContainer>
        <div className="flex justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-4 font-sans text-black">
            <p className="text-xl leading-normal text-black/80">
              Chaque SMS contient un lien unique vers la page planning. Le statut “Lu” est
              enregistré quand le destinataire ouvre ce lien
            </p>
          </div>
          <div className="flex justify-end items-start gap-2">
            <Button variant="outline" className="bg-transparent" disabled>
              Exporter CSV
            </Button>
            <Button disabled>Relancer les non-lus</Button>
          </div>
        </div>
        <SmsTrackingPage />
      </AppContainer>
    </>
  )
}
